import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import elementPlus from 'element-plus'
import './rem'
import './assets/css/element-variables.scss'
import 'normalize.css'
createApp(App).use(router).use(elementPlus).mount('#app')
